import axios from 'axios';
import { authService } from '../authService';
import { 
  PatientForQueue, QueueItem, QueueDisplay, AddToQueueData, 
  CallPatientData, ServiceActionData, SkipQueueData, ApiResponse 
} from './types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const API_BASE = '/queue';

const request = async (url: string, options: any = {}) => {
  try {
    const token = authService.getToken();
    const response = await axios({
      url: `${API_URL}${url}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export const queueApi = {
  getPatientsForQueue: async (serviceType: string = 'doctor', specialty?: string): Promise<ApiResponse<PatientForQueue[]>> => {
    const params = new URLSearchParams({ service_type: serviceType });
    if (specialty) params.append('specialty', specialty);
    return request(`${API_BASE}/patients-for-queue?${params.toString()}`, { method: 'GET' });
  },

  addToQueue: async (data: AddToQueueData): Promise<ApiResponse<any>> => {
    return request(`${API_BASE}/add`, { method: 'POST', data });
  },

  getQueue: async (serviceType: string = 'doctor', status: string = 'waiting'): Promise<ApiResponse<QueueItem[]>> => {
    const params = new URLSearchParams({ service_type: serviceType, status });
    return request(`${API_BASE}/list?${params.toString()}`, { method: 'GET' });
  },

  callPatient: async (data: CallPatientData): Promise<ApiResponse<any>> => {
    return request(`${API_BASE}/call-patient`, { method: 'POST', data });
  },

  startService: async (data: ServiceActionData): Promise<ApiResponse<any>> => {
    return request(`${API_BASE}/start-service`, { method: 'POST', data });
  },

  completeService: async (data: ServiceActionData): Promise<ApiResponse<any>> => {
    return request(`${API_BASE}/complete-service`, { method: 'POST', data });
  },

  skipQueue: async (data: SkipQueueData): Promise<ApiResponse<any>> => {
    return request(`${API_BASE}/skip`, { method: 'POST', data });
  },

  getQueueDisplay: async (serviceType?: string): Promise<ApiResponse<QueueDisplay[]>> => {
    const params = serviceType ? `?service_type=${serviceType}` : '';
    return request(`${API_BASE}/display${params}`, { method: 'GET' });
  }
};
